import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ZoomIn } from 'lucide-react';

const ALL_PHOTOS = [
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-20250626-wa0088.jpg', cat: ['tous', 'reception'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-20250626-wa0075.jpg', cat: ['tous', 'shooting'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-20250516-wa0001.jpg', cat: ['tous', 'reception'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-20250626-wa0074.jpg', cat: ['tous', 'shooting'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-20250505-wa0040.jpg', cat: ['tous', 'reception'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-20250206-wa0022.jpg', cat: ['tous', 'shooting'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-8384.jpg', cat: ['tous', 'shooting'], credit: '@lesnocesdeginkgo' },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-8313.jpg', cat: ['tous', 'shooting'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-8254.jpg', cat: ['tous', 'shooting'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-8403.jpg', cat: ['tous', 'shooting'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/melodysky.jpg', cat: ['tous', 'shooting', 'mariages'], credit: '@Melodysky' },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/melodysky1.jpg', cat: ['tous', 'shooting', 'mariages'], credit: '@Melodysky' },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/melodysky4.jpg', cat: ['tous', 'mariages'], credit: '@Melodysky' },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/melodysky3.jpg', cat: ['tous', 'mariages'], credit: '@Melodysky' },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/melodysky16.jpg', cat: ['tous', 'mariages'], credit: '@Melodysky' },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/melodysky17.jpg', cat: ['tous', 'mariages'], credit: '@Melodysky' },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/melodysky18.jpg', cat: ['tous', 'mariages'], credit: '@Melodysky' },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/melodysky19.jpg', cat: ['tous', 'mariages'], credit: '@Melodysky' },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/20230701-081107_1.jpg', cat: ['tous', 'mariages'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/20230701-095119_1.jpg', cat: ['tous', 'mariages'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/20230826-110757.jpg', cat: ['tous', 'mariages'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-6987.jpg', cat: ['tous', 'mariages'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-7007.jpg', cat: ['tous', 'mariages'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-7252.jpg', cat: ['tous', 'mariages'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-7267.jpg', cat: ['tous', 'mariages'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/whatsapp-image-2022-11-21-at-15-18-09.jpeg', cat: ['tous', 'mariages'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/20241116-112013.jpg', cat: ['tous', 'reception'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/20241116-111434.jpg', cat: ['tous', 'reception'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/20240923-143027.jpg', cat: ['tous', 'reception'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/20240929-105800.jpg', cat: ['tous', 'reception'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-20241027-wa0003.jpg', cat: ['tous', 'reception'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-20241203-wa0042.jpg', cat: ['tous', 'reception'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-20250130-wa0010.jpg', cat: ['tous', 'reception'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/img-20250130-wa0019.jpg', cat: ['tous', 'reception'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/whatsapp-image-2022-11-21-at-15-11-14-2.jpeg', cat: ['tous', 'reception'] },
  { src: 'https://www.lesnocesdeginkgo.ch/uploads/1/3/4/0/134055628/published/alpimages1_1.jpg', cat: ['tous', 'shooting'], credit: '@Alpimages' },
];

const TABS = ['tous', 'mariages', 'shooting', 'reception'];

const Gallery = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('tous');
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => { document.title = `${t('gallery.title')} — Les Noces de Ginkgo`; }, [t]);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') setLightbox(null); };
    if (lightbox) {
      window.addEventListener('keydown', handleKey);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { window.removeEventListener('keydown', handleKey); document.body.style.overflow = ''; };
  }, [lightbox]);

  const filtered = ALL_PHOTOS.filter(p => p.cat.includes(activeTab));

  return (
    <div className="font-sans bg-cream min-h-screen pt-16">

      {/* Header */}
      <section className="bg-ginkgo-900 py-20 md:py-28 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <p className="text-gold text-xs uppercase tracking-[0.3em] font-medium mb-4">
            {t('gallery.subtitle')}
          </p>
          <h1 className="font-serif text-5xl md:text-6xl text-white font-medium">
            {t('gallery.title')}
          </h1>
          <p className="mt-4 text-white/60 text-base max-w-xl mx-auto px-4">
            {t('gallery.description')}
          </p>
        </motion.div>
      </section>

      {/* Tab navigation */}
      <div data-testid="gallery-tabs" className="sticky top-16 z-20 bg-cream/95 backdrop-blur-sm border-b border-stone-200">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <div className="flex items-center gap-0 overflow-x-auto">
            {TABS.map((tab) => (
              <button
                key={tab}
                data-testid={`gallery-tab-${tab}`}
                onClick={() => setActiveTab(tab)}
                className={`px-6 py-4 text-xs uppercase tracking-widest font-medium whitespace-nowrap transition-all border-b-2 ${
                  activeTab === tab
                    ? 'border-ginkgo-800 text-ginkgo-800'
                    : 'border-transparent text-stone-500 hover:text-ginkgo-700'
                }`}
              >
                {t(`gallery.${tab}`)}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Photo grid */}
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-12">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="gallery-grid"
            data-testid="gallery-grid"
          >
            {filtered.map((photo, i) => (
              <div
                key={photo.src}
                className="relative group cursor-pointer mb-3"
                onClick={() => setLightbox(photo)}
                data-testid={`gallery-photo-${i}`}
              >
                <img
                  src={photo.src}
                  alt={`Les Noces de Ginkgo — ${activeTab}`}
                  className="w-full block transition-all duration-500 group-hover:brightness-90"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-ginkgo-900/20">
                  <ZoomIn size={28} className="text-white drop-shadow-lg" />
                </div>
                {photo.credit && (
                  <p className="text-xs text-stone-400 mt-1 pl-1">{photo.credit}</p>
                )}
              </div>
            ))}
          </motion.div>
        </AnimatePresence>

        {filtered.length === 0 && (
          <div className="text-center py-20 text-stone-400">
            <p className="font-serif text-2xl">Bientôt disponible</p>
          </div>
        )}
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {lightbox && (
          <motion.div
            data-testid="lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="lightbox-overlay"
            onClick={() => setLightbox(null)}
          >
            <button
              data-testid="lightbox-close"
              onClick={() => setLightbox(null)}
              className="absolute top-4 right-4 text-white/70 hover:text-white transition-colors z-10"
              aria-label="Close"
            >
              <X size={32} />
            </button>
            <motion.img
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.25 }}
              src={lightbox.src}
              alt="Vue agrandie"
              className="max-w-[92vw] max-h-[92vh] object-contain"
              onClick={(e) => e.stopPropagation()}
            />
            {lightbox.credit && (
              <p className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/50 text-xs">
                {lightbox.credit}
              </p>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Gallery;
